import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Button,
  useTheme,
  Typography,
  Box,
} from "@mui/material";
import { useState, useRef } from "react";
import { baseapi } from "../Environmentalurl";
import {
  ApplicationType,
  date,
  entity_id,
  locationGeo,
  Platform,
} from "../Utils/Const";
import { useSelector } from "react-redux";
import useIPAddress from "../Utils/useIPAddress";
import api from "../Utils/Api";
 
export default function ApplyPhysicalcard({
  open,
  onClose,
  tpin,
  setTpin,
  isDark,
}) {
  const mobile = sessionStorage.getItem("mobileNumber");
  const sessionId = sessionStorage.getItem("SessionID");
 
  const ip = useIPAddress();
  const inputRefs = useRef([]);
  const [statusDialog, setStatusDialog] = useState({
    open: false,
    message: "",
    type: "error",
  });
 
  const theme = useTheme();
  const rupayRefNo = useSelector((state) => state.auth.rupayRefNo);
 
  if (!open) return null;
 
  /* ================= UPDATE PIN FLOW ================= */
  const handleUpdatePin = async () => {
    try {
      if (!rupayRefNo) return;
 
      const payload = {
        ReqType: "Jan_Aadhaar_eWallet_GetCardStatus",
        Mobilenumber: mobile,
        ReferenceNumber: rupayRefNo,
        Platform,
        ApplicationType,
        EntityID: entity_id,
        GeoLocation: locationGeo,
        MachineID: ip,
      };
 
      const cardRes = await api.post(`${baseapi}/getcardstatus`, payload);
      console.log(cardRes.data);
 
      const hexOldRes = await api.post(`${baseapi}/hexXorgenerator`, {
        rpin: tpin,
        mobilenumber: mobile,
      });
 
      const hexOld = hexOldRes.data;
 
      const encOldRes = await api.post(
        `${baseapi}/ewalletRupayEncryption3DES`,
        {
          ReqType: "Jan_Aadhaar_eWallet_RupayEncryption3DES",
          Mobilenumber: mobile,
          Enc_Key: cardRes.data.EncKey,
          Date: date,
          Hex_XOR_Value: hexOld,
          SessionID: sessionId,
          Platform,
          ApplicationType,
          EntityID: entity_id,
          GeoLocation: locationGeo,
          MachineID: ip,
        },
      );
 
      const encOld = encOldRes.data;
      console.log(encOld);
 
      const hexNewRes = await api.post(`${baseapi}/hexXorgenerator`, {
        rpin: tpin,
        mobilenumber: mobile,
      });
 
      const hexNew = hexNewRes.data;
      console.log(hexNew);
 
      const encNewRes = await api.post(
        `${baseapi}/ewalletRupayEncryption3DES`,
        {
          ReqType: "Jan_Aadhaar_eWallet_RupayEncryption3DES",
          Mobilenumber: mobile,
          Enc_Key: cardRes.data.EncKey,
          Date: date,
          Hex_XOR_Value: hexNew,
          SessionID: sessionId,
          Platform,
          ApplicationType,
          EntityID: entity_id,
          GeoLocation: locationGeo,
          MachineID: ip,
        },
      );
 
      const encNew = encNewRes.data;
 
      const finalResObj = await api.post(
        `${baseapi}/eWalletRequestPhysicalCard`,
        {
          ReqType: "Jan_Aadhaar_eWallet_RequestPhysicalCard",
          Mobilenumber: mobile,
          Date: date,
          CardNumber: cardRes.data.MaskedCard,
          SessionID: sessionId,
          EntityID: entity_id,
          ReferenceNumber: rupayRefNo,
          MachineID: ip,
          Platform,
          ApplicationType,
          GeoLocation: locationGeo,
          R_PIN: encOld.RPIN,
          Address: "",
        },
      );
 
      const finalRes = finalResObj.data;
      console.log(finalRes);
 
      if (finalRes.Response_Code === "49976") {
        setStatusDialog({
          open: true,
          message: finalRes.Message,
          type: "error",
        });
      } else if (finalRes.Response_Code === "1000") {
        setStatusDialog({
          open: true,
          message: "✅ Physical card request submitted successfully",
          type: "success",
        });
      } else {
        setStatusDialog({
          open: true,
          message: finalRes.Message || "Something went wrong",
          type: "error",
        });
      }
    } catch (error) {
      console.error(error);
    }
  };
 
  return (
    <>
      {/* ───── TPIN Entry Dialog ───── */}
      <Dialog
        open={open}
        onClose={onClose}
        PaperProps={{
          sx: {
            borderRadius: "16px",
            padding: "6px",
            width: "380px",
            backgroundColor: isDark ? "#1d2633" : "#fefefe",
            boxShadow: "0 8px 28px rgba(0,0,0,0.18)",
          },
        }}
      >
        <DialogTitle
          sx={{
            fontWeight: "bold",
            fontSize: "20px",
            textAlign: "center",
            color: isDark ? "#fff" : "#114c28",
          }}
        >
          🔐 Enter TPIN
        </DialogTitle>
 
        <DialogContent sx={{ px: 4 }}>
          <Box sx={{ mt: 1 }}>
            <Typography
              variant="body2"
              sx={{ mb: 1, color: "text.secondary", fontWeight: 500 }}
            >
              Enter 4-Digit TPIN
            </Typography>
 
            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                gap: 1.5,
              }}
            >
              {[0, 1, 2, 3].map((index) => (
                <TextField
                  key={index}
                  type="password"
                  autoComplete="off"
                  value={tpin[index] || ""}
                  inputRef={(el) => (inputRefs.current[index] = el)}
                  onChange={(e) => {
                    const value = e.target.value.replace(/\D/g, "").slice(-1);
 
                    // ✅ Fixed: clean array approach, no space padding
                    const arr = tpin.split("");
                    arr[index] = value;
                    const newTpin = arr.join("");
                    setTpin(newTpin);
 
                    if (value && index < 3) {
                      inputRefs.current[index + 1]?.focus();
                    }
                  }}
                  onKeyDown={(e) => {
                    if (e.key === "Backspace") {
                      if (tpin[index]) {
                        // Clear current box
                        const arr = tpin.split("");
                        arr[index] = "";
                        setTpin(arr.join(""));
                      } else if (index > 0) {
                        // Move to previous box and clear it
                        const arr = tpin.split("");
                        arr[index - 1] = "";
                        setTpin(arr.join(""));
                        inputRefs.current[index - 1]?.focus();
                      }
                    }
                  }}
                  inputProps={{
                    maxLength: 1,
                    inputMode: "numeric",
                    style: {
                      textAlign: "center",
                      fontSize: "22px",
                      fontWeight: 600,
                    },
                  }}
                  sx={{
                    width: 60,
                    "& .MuiOutlinedInput-root": {
                      height: 60,
                      borderRadius: "14px",
                      backgroundColor: isDark ? "#2d3748" : "#fff",
                    },
                  }}
                />
              ))}
            </Box>
          </Box>
        </DialogContent>
 
        <DialogActions sx={{ px: 3, pb: 2 }}>
          <Button onClick={onClose}>Cancel</Button>
 
          <Button
            variant="contained"
            disabled={tpin.length !== 4}
            onClick={handleUpdatePin}
          >
            Verify
          </Button>
        </DialogActions>
      </Dialog>
 
      {/* ───── Status Dialog ───── */}
      <Dialog
        open={statusDialog.open}
        onClose={() => setStatusDialog({ ...statusDialog, open: false })}
        PaperProps={{
          sx: {
            borderRadius: "16px",
            p: 3,
            width: 380,
            textAlign: "center",
            backgroundColor: isDark ? "#1d2633" : "#ffffff",
          },
        }}
      >
        <DialogTitle
          sx={{
            fontWeight: 700,
            color: statusDialog.type === "success" ? "#22c55e" : "#ef4444",
          }}
        >
          {statusDialog.type === "success" ? "✅ Success" : "❌ Error"}
        </DialogTitle>
 
        <DialogContent>
          <Typography
            sx={{
              fontSize: 14,
              color: isDark ? "#e5e7eb" : "#374151",
              mt: 1,
            }}
          >
            {statusDialog.message}
          </Typography>
        </DialogContent>
 
        <DialogActions sx={{ justifyContent: "center", mt: 2 }}>
          <Button
            variant="contained"
            onClick={() => {
              setStatusDialog({ ...statusDialog, open: false });
              onClose();
              setTpin("");
            }}
            sx={{ color: "white" }}
          >
            OK
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}
 
 